import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { RadioButtonGroupModule } from 'NewAngular/features/components/inputs/radio-button-group/radio-button-group.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { IndexOfPipeModule } from 'NewAngular/features/pipes/index-of/index-of-pipe.module';
import { IconSearchAutocompleteModule } from 'SearchApp/ts/features/icon-search-autocomplete/icon-search-autocomplete.module';
import * as i0 from "@angular/core";
export class SecurityListSelectorModalModule {
}
SecurityListSelectorModalModule.ɵfac = function SecurityListSelectorModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SecurityListSelectorModalModule)(); };
SecurityListSelectorModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SecurityListSelectorModalModule });
SecurityListSelectorModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        FeatureNeededModule,
        FormsModule,
        IconModule,
        IconSearchAutocompleteModule,
        IndexOfPipeModule,
        LoadingSymbolModule,
        ModalBaseModule,
        RadioButtonGroupModule] });
